import Controller from './Controller'
import {
  initPlayground,
  stopPlayground,
  destroyPlayground,
} from '../playground'


class HomePlayController extends Controller {
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e);
    // ### Playground (ZNAKI installation) ###
    const container = document.querySelector(this.getContainerSelector());
    if (container) {
      initPlayground(container);
    }
  }
  /**
  * on view hidden - animation hidden complete
  * @param {Event} e
  **/
  onViewHidden(e) {
    super.onViewHidden(e);
    // ### Playground ###
    destroyPlayground();
  }
  removeEventListeners() {
    super.removeEventListeners();
    // ### Playground ### - pause the loop as soon as the view starts leaving
    stopPlayground();
  }

}

export default HomePlayController;
